module.exports = __webpack_public_path__ + "static/media/02-mainmenu.06c950f4.png";